/**
 * Created by m.igrachev on 7/20/2017.
 */
export default function isClickOutside(event, outsideOf) {
    let outside = true;
    let eventTarget = event.target; //No default - assuming events always have target!
    if (event.type === "blur") {
        //For blur events IE11 does not support relatedTarget, instead they support proper value of activeElement.
        //However normal browsers support related target and do not support activeElement.
        eventTarget = event.relatedTarget || document.activeElement;
    }
    let target = eventTarget;
    while (target) {
        if (target === outsideOf) {
            outside = false;
            break;
        }
        target = target.parentNode;
    }
    return outside;
}
